import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * SPA route tracking helper.
 * GTM and GA4 (gtag.js) are loaded directly in /public/index.html.
 * This component pushes a 'page_view' event to BOTH on each SPA route change.
 */
export default function Analytics() {
  const location = useLocation();

  useEffect(() => {
    if (typeof window === "undefined") return;

    // GTM dataLayer page_view
    if (window.dataLayer) {
      window.dataLayer.push({
        event: "page_view",
        page_path: location.pathname + location.search,
        page_location: window.location.href,
        page_title: document.title,
      });
    }

    // GA4 gtag page_view
    if (window.gtag) {
      window.gtag("event", "page_view", {
        page_path: location.pathname + location.search,
        page_location: window.location.href,
        page_title: document.title,
      });
    }
  }, [location]);

  return null;
}
